module.exports = __webpack_public_path__ + "images/599b35eacbc0dbb195846a00e944659cf450d34f52862bb4b9511a44a2e61f19.svg";